<template lang="html">
  <svg class="icon-svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.75 0C16.5449 0 18 1.45507 18 3.25V10H13.25C11.4551 10 10 11.4551 10 13.25V18H3.25C1.45507 18 0 16.5449 0 14.75V3.25C0 1.45507 1.45507 0 3.25 0H14.75ZM17.56 11.5L11.5 17.56V13.25C11.5 12.2835 12.2835 11.5 13.25 11.5H17.56Z" fill="#ADA8A8"/>
  </svg>

</template>
<script>
    export default {
        name: 'IconNote'
    }
</script>



// WEBPACK FOOTER //
// src/components/IconNote.vue